import React from 'react'

import { CardContainer } from './styles'

interface SimpleCardProps {
  children: React.ReactNode
  width?: string
  height?: string
  minWidth?: string
  minHeight?: string
  maxWidth?: string
  maxHeight?: string
  padding?: string
  marginTop?: string
}

const SimpleCard: React.FC<SimpleCardProps> = ({
  children,
  width,
  height,
  minHeight,
  minWidth,
  maxHeight,
  maxWidth,
  padding,
  marginTop,
}) => {
  return (
    <CardContainer
      padding={padding}
      width={width}
      height={height}
      minHeight={minHeight}
      minWidth={minWidth}
      maxHeight={maxHeight}
      maxWidth={maxWidth}
      marginTop={marginTop}
    >
      {children}
    </CardContainer>
  )
}

export default SimpleCard
